import { LayoutMode } from "../../../../components/layout/types";
import { LayoutActionKey } from "../../../actions/ActionKeys";
import { LayoutAction } from "../../../actions/layout";

export const layoutMode = (
  state: LayoutMode = "column",
  action: LayoutAction
) => {
  switch (action.type) {
    case LayoutActionKey.SET_LAYOUT_MODE:
      return action.payload.mode;
    default:
      return state;
  }
};
